import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=5c924104&scoped=true&"
import script from "./banner.vue?vue&type=script&lang=js&"
export * from "./banner.vue?vue&type=script&lang=js&"
import style0 from "./banner.vue?vue&type=style&index=0&id=5c924104&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c924104",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VImg,VLayout})
